<template>
  <div class="May2022 text-NotoSansLight">
    <section class="banner md:pt-20">
      <div class="flex max-w-6xl mx-auto">
        <div class="hidden md:block"><img src="~@/assets/images/202205/top/top2.png" class="object-contain"></div>
        <div class="hidden md:block"><img src="~@/assets/images/202205/top/top1.png" class="object-contain"></div>
        <div class="hidden md:block"><img src="~@/assets/images/202205/top/top3.png" class="object-contain"></div>
        <div class="md:hidden"><img src="~@/assets/images/202205/top/main.png" class="object-contain"></div>
      </div>
    </section>
    <section class="planTags">
      <div class="flex max-w-6xl mx-auto flex-wrap">
        <div class="flex w-full md:w-1/3 py-4 md:py-0" @click="toTop(3)">
          <div class="flag hidden md:block"><img src="~@/assets/images/202205/top/tag1.png" class="object-contain"></div>
          <div class="hidden md:block"><img src="~@/assets/images/202205/top/menu1.png" class="object-contain"></div>
          <div class="md:hidden"><img src="~@/assets/images/202205/top/menu1_mobile.png" class="object-contain"></div>
        </div>
        <div class="flex w-full md:w-1/3 pb-4 md:py-0" @click="toTop(4)">
          <div class="flag hidden md:block"><img src="~@/assets/images/202205/top/tag2.png" class="object-contain"></div>
          <div class="hidden md:block"><img src="~@/assets/images/202205/top/menu2.png" class="object-contain"></div>
          <div class="md:hidden"><img src="~@/assets/images/202205/top/menu2_mobile.png" class="object-contain"></div>
        </div>
        <div class="flex w-full md:w-1/3 pb-4 md:py-0" @click="toTop(5)">
          <div class="flag hidden md:block"><img src="~@/assets/images/202205/top/tag3.png" class="object-contain"></div>
          <div class="hidden md:block"><img src="~@/assets/images/202205/top/menu3.png" class="object-contain"></div>
          <div class="md:hidden"><img src="~@/assets/images/202205/top/menu3_mobile.png" class="object-contain"></div>
        </div>
      </div>
    </section>

    <!-- 訂雜誌最省錢 -->
    <section class="section3 py-8 md:py12" id="section3">
      <div class="flex max-w-6xl mx-auto justify-center flex-wrap">
        <div class="w-full md:w-1/3 order-3 md:order-1 hidden md:block"><img src="~@/assets/images/202205/C1/c1-pop2.png" class="object-contain"></div>
        <div class="w-full md:w-1/3 order-1 md:order-2 mb-6 md:mb-0">
          <img src="~@/assets/images/202205/C1/c1-tit1.png" class="object-contain hidden md:block">
          <img src="~@/assets/images/202205/C1/c1-tit_m.png" class="object-contain md:hidden">
        </div>
        <div class="w-full md:w-1/3 order-2 md:order-3 mb-10 md:mb-0 px-4 md:px-0"><img src="~@/assets/images/202205/C1/c1-pop1.png" class="object-contain"></div>
      </div>
      <div class="bookList bookList1 bg-white py-6 pb-10 lg:py-10 px-4 lg:px-8 border-t-2 border-b-2 border-black relative max-w-6xl mx-auto">
        <a class="title-label mx-auto inline-block">
          <img src="~@/assets/images/202205/C1/c1-tit2.png" class="object-contain">
        </a>
        <div class="flex flex-wrap">
          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="item w-1/2 md:w-1/3 p-2 md:p-4 cursor-pointer" v-for="(item, idx) in planData" :key="idx">

            <div class="item-inner bg-white rounded-3xl p-4 h-full flex flex-col justify-between border-2 border-blue" v-if="renderComponent">
              <div>
                <div class="title p-1 rounded-lg xl:rounded-full mb-4">
                  <h6 class="text-white text-center text-base md:text-lg xl:text-2xl">{{ item.introduction }}</h6>
                </div>
                <div class="outer mb-2">
                  <div class="inner mx-auto border-0 absolute w-full h-full">
                    <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!item.cover">
                    <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                  </div>
                </div>
              </div>

              <!-- <div class="flex justify-center mt-3 slogan">
                <p>15期特價1880</p>
              </div> -->
            </div>
          </router-link>
        </div>
        <a class="more-btn absolute" href="https://store.liveabc.com/products/magazine/sale?tag=154">
          <img src="~@/assets/images/202205/more.png" class="object-contain">
        </a>
      </div>
    </section>
    <!-- 點讀套書折現 -->
    <section class="section4 py-8 md:py12" id="section4">
      <div class="flex container justify-center flex-wrap">
        <div class="w-full md:w-1/3 order-3 md:order-1 hidden md:block"><img src="~@/assets/images/202205/C1/c1-pop2.png" class="object-contain opacity-0"></div>
        <div class="w-full md:w-1/3 order-1 md:order-2 mb-6 md:mb-0">
          <img src="~@/assets/images/202205/C2/c2-tit.png" class="object-contain hidden md:block">
          <img src="~@/assets/images/202205/C2/c2-tit_m.png" class="object-contain md:hidden">
        </div>
        <div class="w-full md:w-1/3 order-2 md:order-3 mb-10 md:mb-0 px-4 md:px-0"><img src="~@/assets/images/202205/C2/c2-pop.png" class="object-contain"></div>
      </div>
      <div class="bookList bookList2 bg-white py-6 pb-10 lg:py-10  border-t-2 border-b-2 border-black relative max-w-6xl mx-auto">
        <a class="title-label mx-auto inline-block">
          <img src="~@/assets/images/202205/C2/c3-tit2.png" class="object-contain">
        </a>

        <div class="flex flex-wrap">

          <div class="py-4" v-for="(item, index) in sectionData" :key="index" :id="'section' + index">
            <div class="flex justify-center items-center mb-4 md:mb-8">
              <div class="">
                <img :src="item.img_url" class="object-contain mx-auto hidden md:block">
                <img :src="item.img_url_m" class="object-contain mx-auto md:hidden">
              </div>
            </div>

            <div class="flex flex-wrap mb-6 px-4 lg:px-8">
              <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 md:w-1/3 lg:w-1/4 p-3 cursor-pointer relative" v-for="(child, idx) in item.items" :key="idx">
                <div class="hot absolute" v-if="idx === 0 && item.label_url"><img :src="item.label_url" class="object-contain block"></div>
                <div class="item-inner bg-white rounded-3xl p-3 md:p-6 h-full flex flex-col justify-between hover:shadow-lg shadow-gray-900 border-2 border-blue " v-if="renderComponent">
                  <div>
                    <div class="title p-1 rounded-lg xl:rounded-full mb-3">
                      <h6 class="text-white text-center text-sm md:text-base">{{ child.introduction }}</h6>
                    </div>
                    <div class="outer mb-2">
                      <div class="inner mx-auto border-0 p-2 md:p-3 absolute w-full h-full">
                        <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                        <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                      </div>
                    </div>
                    <div>
                      <div>
                        <dealBookName :nameVal="child.name" v-if="child.name" class="text-center whitespace-pre-wrap" />
                      </div>
                    </div>
                  </div>

                  <div class="flex md:justify-center md:items-end mt-3 flex-wrap" v-if="child.name">
                    <p v-if="child.type === 'PACKAGE'" class="fixed_price line-through">原價:{{ child.fixed_price }}</p>
                    <p v-if="child.type === 'BOOK'"><span class="pricing">{{ child.display_discount }}</span>折</p>
                    <p>特價:<span class="pricing">{{ child.pricing }}</span></p>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <a class="more-btn absolute" href="https://store.liveabc.com/products/livepen?scope=livepen">
          <img src="~@/assets/images/202205/more.png" class="object-contain">
        </a>
      </div>
    </section>
    <!-- 任選專區 -->
    <section class="section5 py-8 md:py12" id="section5">
      <div class="flex container justify-center flex-wrap">
        <div class="w-full md:w-1/3 order-3 md:order-1 hidden md:block"><img src="~@/assets/images/202205/C1/c1-pop2.png" class="object-contain opacity-0"></div>
        <div class="w-full md:w-1/3 order-1 md:order-2 mb-6 md:mb-0">
          <img src="~@/assets/images/202205/C3/c3-tit.png" class="object-contain hidden md:block">
          <img src="~@/assets/images/202205/C3/c3-tit_m.png" class="object-contain md:hidden">
        </div>
        <div class="w-full md:w-1/3 order-2 md:order-3 mb-10 md:mb-0 px-4 md:px-0"><img src="~@/assets/images/202205/C3/c3-pop.png" class="object-contain"></div>
      </div>
      <div class="bookList bookList3 bg-white py-6 pb-10 lg:py-10 px-4 lg:px-8 border-t-2 border-b-2 border-black relative max-w-6xl mx-auto">
        <a class="title-label mx-auto inline-block">
          <img src="~@/assets/images/202205/C3/c3-tit2.png" class="object-contain">
        </a>
        <div class="flex flex-wrap">

          <div class="py-4" v-for="(item, index) in sectionData2" :key="index" :id="'section' + index">
            <div class="flex flex-wrap mb-6">
              <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 md:w-1/3 lg:w-1/4 p-3 cursor-pointer" v-for="(child, idx) in item.items" :key="idx">

                <div class="item-inner bg-white rounded-3xl p-3 md:p-6 h-full flex flex-col justify-between hover:shadow-lg shadow-gray-900 border-2 border-blue" v-if="renderComponent">
                  <div>
                    <div class="title p-1 rounded-lg xl:rounded-full mb-3">
                      <h6 class="text-white text-center text-sm md:text-base">{{ child.introduction }}</h6>
                    </div>
                    <div class="outer mb-2">
                      <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full">
                        <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                        <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                      </div>
                    </div>
                    <div>
                      <div>
                        <dealBookName :nameVal="child.name" v-if="child.name" class="text-center whitespace-pre-wrap" />
                      </div>
                    </div>
                  </div>

                  <div class="flex md:justify-center md:items-end mt-3 flex-wrap" v-if="child.name">
                    <p v-if="child.type === 'PACKAGE'" class="fixed_price line-through">原價:{{ child.fixed_price }}</p>
                    <p v-if="child.type === 'BOOK'"><span class="pricing">{{ child.display_discount }}</span>折</p>
                    <p>特價:<span class="pricing">{{ child.pricing }}</span></p>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <a class="more-btn absolute" href="https://store.liveabc.com/products/magazine/sale?tag=153">
          <img src="~@/assets/images/202205/more.png" class="object-contain">
        </a>
      </div>
    </section>
    <!-- 注意事項 -->
    <section class="note flex justify-center w-full py-8 md:py12 pb-24">
      <div class="py-3 px-10 leading-loose text-lg lg:text-2xl font-bold tracking-wider">
        <div class="flex container justify-center mb-4 w-full">
          <!-- <div class="w-1/3"><img src="~@/assets/images/202205/C1/c1-pop2.png" class="object-contain opacity-0"></div> -->
          <div class="w-2/3 md:w-1/3"><img src="~@/assets/images/202205/at.png" class="object-contain"></div>
          <!-- <div class="w-1/3"><img src="~@/assets/images/202205/C3/c3-pop.png" class="object-contain"></div> -->
        </div>
        <!-- <p>注意事項</p> -->
        <ul class="list-decimal list-outside">
          <li>本公司保留替換其他等值獎項及變更、修改本活動之權利。</li>
          <li>活動已官網公告為主，凡有變更則不另加通知。</li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
import axios from 'axios'
import jump from 'jump.js'
import dealBookName from '@/components/modules/dealBookName'
export default {
  name: 'April2022',
  metaInfo () {
    return {
      title: '繳稅季不吃土 LiveABC線上國際書展',
      titleTemplate: null
    }
  },
  components: {
    dealBookName
  },
  data () {
    return {
      linksOfftop: 0,
      isFixed: false,
      renderComponent: true,
      planData: [
        { id: 7779, type: 'abc', introduction: '初級/基礎/活用', text: '6期特價990' },
        { id: 7781, type: 'live', introduction: '中級/生活/實用', text: '6期特價990' },
        { id: 7784, type: 'all', introduction: '中高級/進階/應用', text: '6期特價990' },
        { id: 7786, type: 'cnn', introduction: '新聞/時事/新知', text: '6期特價990' },
        { id: 7788, type: 'jp', introduction: '初級/生活/實用', text: '6期特價990' },
        { id: 7790, type: 'hiw', introduction: '圖解/百科/符合108課綱', text: '6期特價990' }
      ],
      sectionData: [
        {
          img_url: require('@/assets/images/202205/C2/c2-1.png'),
          img_url_m: require('@/assets/images/202205/C2/c2-1_m.png'),
          label_url: require('@/assets/images/202205/hot.png'),
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 7082, introduction: '臨場說英語不再掉漆' },
            { id: 7100, introduction: '圖解輕鬆學實用英語字彙' },
            { id: 7512, introduction: '掌握多益聽力考題' },
            { id: 7087, introduction: '每天用的到的日語實用句' }
          ]
        },
        {
          img_url: require('@/assets/images/202205/C2/c2-2.png'),
          img_url_m: require('@/assets/images/202205/C2/c2-2_m.png'),
          // label_url: require('@/assets/images/202205/new.png'),
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 6569, introduction: '道地口音加強聽說能力' },
            { id: 7208, introduction: '新世代用語你不能不知' },
            { id: 6769, introduction: '真人情境影片快速學習' },
            { id: 6606, introduction: '學貼近生活的主體超有感' }
          ]
        },
        {
          img_url: require('@/assets/images/202205/C2/c2-3.png'),
          img_url_m: require('@/assets/images/202205/C2/c2-3_m.png'),
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=113',
          items: [
            { id: 7235, introduction: '和佩佩豬一起唱跳學英語' },
            { id: 7701, introduction: '看卡通圖片輕鬆學單字' },
            { id: 5936, introduction: '小學生英語必備' },
            { id: 7068, introduction: '原汁原味學好英式發音' }
          ]
        },
        {
          img_url: require('@/assets/images/202205/C2/c2-4.png'),
          img_url_m: require('@/assets/images/202205/C2/c2-4_m.png'),
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=117',
          items: [
            { id: 7386, introduction: '快速學會簡報及會議用語' },
            { id: 7388, introduction: '讓你職場英語迅速上手' },
            { id: 6609, introduction: '多益高分沒問題' },
            { id: 6568, introduction: '出國留學檢測必備' }
          ]
        }
      ],
      sectionData2: [
        {
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 7434, introduction: '聽懂新聞聊天不缺話題' },
            { id: 7161, introduction: '閱讀是英語學習的基礎' },
            { id: 7002, introduction: '網路社群用語快學起來' },
            { id: 7013, introduction: '別讓片語限制了英語程度' },
            { id: 6521, introduction: '會唸才能派得上用場' },
            { id: 6245, introduction: '27篇經典作品值得收藏' },
            { id: 6238, introduction: '老外都在說的英語短句' },
            { id: 5995, introduction: '500個必學口語用法' },
            { id: 7732, introduction: '了解慣用語掌握使用情境' },
            { id: 7649, introduction: '圖解學日語好輕鬆' },
            { id: 7403, introduction: '無痛學好日語單字' },
            { id: 7284, introduction: '精準收錄N2必考單字' },
            { id: 7401, introduction: '追劇時順便學韓語' },
            { id: 7014, introduction: '跟著KPOP愛豆學韓語' },
            { id: 6873, introduction: '哈韓族學韓語必備' },
            { id: 6302, introduction: '去韓國你要會的700句' }
          ]
        }
      ],
      pageSize: 20
    }
  },
  async mounted () {
    await this.getEvent()
  },
  destroyed () {
  },
  methods: {
    async getEvent () {
      let self = this
      for (let i = 0; i < self.sectionData.length; i++) {
        await self.getData(i, self.sectionData[i].items)
      }
      for (let i = 0; i < self.sectionData2.length; i++) {
        await self.getData(i, self.sectionData2[i].items)
      }
      self.getData2(self.planData)
      // self.getData2(self.presentsData)
      // self.getData2(self.presentsData2)
    },
    getData (idx, itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }

      axios.get(`/products?list=${pathArr.toString()}&pageSize=${self.pageSize}`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },
    getData2 (itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}&pageSize=${self.pageSize}`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },

    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    toTop (n) {
      jump(`#section${n}`, {
        duration: 500,
        offset: 0
      })
    },
    replace (name) {
      return name.replace(' ', '<br/>')
    }
  }
}
</script>
<style lang="scss" scoped>
.rounded-3xl {
  border-radius: 1.5rem;
}
.pricing {
  color: #ff0000;
}
.border-blue {
  border-color: #b9bec2;
}
.outer {
  position: relative;
  width: 100%;
  background:white;
  display: block;
  &:after {
    content: "";
    display: block;
    padding-Bottom: 100%;
  }
  .inner {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.title {
  background-color: #ff781f;
  @media (max-width: 1024px) {
    min-height: 56px;
  }
  @media (max-width: 768px) {
    min-height: 50px;
  }
}
.fixed_price {
  text-decoration-color: red;
}
.May2022 {
  // background-color: #F3BBAB;
  background-image: url('~@/assets/images/202205/bg_dot.png');
  background-size: contain;
  .planTags {
    background-color: #fff2b8;
    .flag {
      img {
        margin-top: -16px;
        @media (max-width: 768px) {
          margin-top: -12px;
        }
        @media (max-width: 640px) {
          margin-top: -10px;
        }
        @media (max-width: 640px) {
          margin-top: -6px;
        }
      }
    }
  }
  .section3 {
    background-color: #ffeb92;
  }
  .section4 {
    background-color: #fed977;
  }
  .section5 {
    background-color: #ffeb92;
  }
  .bookList {
    .title-label {
      width: 100%;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      // width: 100%;
      // margin-top: -12em;
      @media (max-width: 768px) {
        width: 80%;
      }
      img {
        margin-left: auto !important;
        margin-right: auto !important;
        height: 70px;
        @media (max-width: 768px) {
          height: 60px;
        }
      }
    }
    .item {
      .hot {
        position: absolute;
        left: -4%;
        top: -4%;
        width: 85px;
        @media (max-width: 768px) {
          width: 85px;
          left: -5%;
          top: -5%;
          width: 80px;
        }
        // transform: translate(50%, 50%);
      }
      .item-inner {
        // min-height: 360px;
        // transition: .3s;
        // &:hover {
        //   transform: translateY(-15px);
        // }
      }
    }
    .more-btn {
      display: inline-block;
      position: absolute;
      // width: 100%;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 50%);
      // width: 100%;
      // margin-top: -12em;
      @media (max-width: 768px) {
        width: 80%;
      }
      img {
        margin: 0 auto;
      }
      // bottom: 0;
      // left: 50%;
      // transform: translate(-50%, -50%);
    }
  }
  .note {
    background-color: #ffeb92;
    color: #4e4c45;
  }
  background-attachment: fixed;
}
</style>
